import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAirplay"><Path d="M22 3H2V18H7V16.5H3.5V4.5H20.5V16.5H17V18H22V3Z" fill="currentColor"/><Path d="M6.48633 20.9993L12.0006 13.7617L17.515 20.9993H6.48633Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirplay;
